module.exports = __webpack_public_path__ + "img/ground.d29868a6.png";